(function () {
'use strict';
var d = document, w = window;
var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
var q = function (s, r) { return (r || d).querySelector(s); };
var qa = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
function reveal() {
var main = q('#MainContent');
if (main) qa(':scope > .shopify-section', main).forEach(function (s, i) {
if (i > 0 && !s.hasAttribute('data-tv-reveal') && !s.querySelector('.tv-product-clarity')) s.setAttribute('data-tv-reveal', '');
});
var items = qa('[data-tv-reveal]:not(.is-in), .tv2-reveal:not(.is-in), .tv-teaser__visual:not(.is-in)');
if (reduce || !('IntersectionObserver' in w)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
}, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
items.forEach(function (el) {
var r = el.getBoundingClientRect();
if (r.top < w.innerHeight && r.bottom > 0) el.classList.add('is-in'); else io.observe(el);
});
}
function press() {
var sel = '.button, .tv-btn, .tv2-btn, .tv-tile, .tv-card, .tv-chip, .tv-continue__link, .tv-pair, .tv-inside__card, .card-wrapper';
d.addEventListener('pointerdown', function (e) {
var el = e.target.closest(sel); if (!el) return;
el.classList.add('is-pressed');
var up = function () { el.classList.remove('is-pressed'); d.removeEventListener('pointerup', up); d.removeEventListener('pointercancel', up); };
d.addEventListener('pointerup', up); d.addEventListener('pointercancel', up);
}, { passive: true });
}
function header() {
var on = false, t;
var check = function () {
var s = w.scrollY > 48;
if (s !== on) { on = s; d.documentElement.classList.toggle('tv-scrolled', s); }
};
w.addEventListener('scroll', function () { if (!t) t = requestAnimationFrame(function () { t = 0; check(); }); }, { passive: true });
check();
}
function dots() {
qa('[data-tv-dots-for]').forEach(function (box) {
if (box.dataset.tvReady) return;
var sc = q(box.dataset.tvDotsFor); if (!sc) return;
var track = box.dataset.tvDotsTrack ? q(box.dataset.tvDotsTrack, sc) || sc : sc;
var items = qa(':scope > *', track).filter(function (i) { return i.offsetParent !== null; });
if (items.length < 2) { box.innerHTML = ''; return; }
box.dataset.tvReady = '1';
box.innerHTML = '';
var btns = items.map(function (it, i) {
var b = d.createElement('button'); b.type = 'button'; b.className = 'tv-dots__dot'; b.setAttribute('aria-label', 'Go to item ' + (i + 1));
b.addEventListener('click', function () { sc.scrollTo({ left: it.offsetLeft - (sc.clientWidth - it.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); });
box.appendChild(b); return b;
});
var set = function () {
var mid = sc.scrollLeft + sc.clientWidth / 2, best = 0, bd = 1e9;
items.forEach(function (it, i) { var c = it.offsetLeft + it.offsetWidth / 2, dd = Math.abs(c - mid); if (dd < bd) { bd = dd; best = i; } });
btns.forEach(function (b, i) { b.classList.toggle('is-active', i === best); b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
};
var t; sc.addEventListener('scroll', function () { if (!t) t = requestAnimationFrame(function () { t = 0; set(); }); }, { passive: true });
set();
});
}
function switchers() {
qa('.tv-switch').forEach(function (sw) {
if (sw.dataset.tvReady) return; sw.dataset.tvReady = '1';
var tabs = qa('.tv-switch__tab', sw), bar = q('.tv-switch__bar', sw);
if (!bar) { bar = d.createElement('span'); bar.className = 'tv-switch__bar'; sw.appendChild(bar); }
var root = sw.closest('[data-tv-switch-root]') || sw.parentElement;
var move = function (tab) { bar.style.left = tab.offsetLeft + 'px'; bar.style.width = tab.offsetWidth + 'px'; };
var select = function (tab, focus) {
tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); t.tabIndex = t === tab ? 0 : -1; });
qa('.tv-panel', root).forEach(function (p) { p.hidden = p.dataset.panel !== tab.dataset.panel; });
move(tab); if (focus) tab.focus();
if (sw.scrollWidth > sw.clientWidth) sw.scrollTo({ left: tab.offsetLeft - (sw.clientWidth - tab.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
dots();
};
tabs.forEach(function (t, i) {
t.addEventListener('click', function () { select(t); });
t.addEventListener('keydown', function (e) {
var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -1;
if (n > -1 && tabs[n]) { e.preventDefault(); select(tabs[n], true); }
});
});
sw.tvSelect = function (panel) { var t = tabs.filter(function (x) { return x.dataset.panel === panel; })[0]; if (t) select(t); };
var cur = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
if (cur) select(cur);
w.addEventListener('resize', function () { var c = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0]; if (c) move(c); });
});
}
function tiles() {
d.addEventListener('click', function (e) {
var j = e.target.closest('[data-tv-jump]'); if (!j) return;
var sw = q('.tv-ladder .tv-switch'); var card = j.dataset.tvJump ? q('#tv-set-' + j.dataset.tvJump) : null;
if (!sw || !sw.tvSelect) return;
e.preventDefault();
qa('.tv-tile.is-active').forEach(function (t) { t.classList.remove('is-active'); });
var tile = j.closest('.tv-tile'); if (tile) tile.classList.add('is-active');
if (j.dataset.tvPieces) sw.tvSelect(j.dataset.tvPieces);
var target = card || q('.tv-ladder');
target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: card ? 'center' : 'start', inline: 'center' });
if (card) { card.classList.add('is-jumped'); setTimeout(function () { card.classList.remove('is-jumped'); }, 2600); }
});
}
function gallery() {
var list = q('.tv-product-clarity .product__media-list'); if (!list || list.dataset.tvReady) return;
list.dataset.tvReady = '1';
if (!list.id) list.id = 'tv-gallery-list';
var box = d.createElement('div'); box.className = 'tv-dots tv-gallery-dots'; box.setAttribute('data-tv-dots-for', '#' + list.id); box.setAttribute('aria-label', 'Gallery');
(list.closest('slider-component') || list).insertAdjacentElement('afterend', box);
dots();
var pts = {}, img = null, start = 0, mid = null;
var dist = function () { var k = Object.keys(pts); if (k.length < 2) return 0; var a = pts[k[0]], b = pts[k[1]]; return Math.hypot(a.x - b.x, a.y - b.y); };
list.addEventListener('pointerdown', function (e) {
if (e.pointerType !== 'touch') return;
pts[e.pointerId] = { x: e.clientX, y: e.clientY };
if (Object.keys(pts).length === 2) {
img = e.target.closest('.product__media') && q('img', e.target.closest('.product__media'));
if (!img) return; start = dist();
var k = Object.keys(pts), a = pts[k[0]], b = pts[k[1]], r = img.getBoundingClientRect();
mid = { x: ((a.x + b.x) / 2 - r.left) / r.width * 100, y: ((a.y + b.y) / 2 - r.top) / r.height * 100 };
img.classList.add('is-pinching'); img.style.transformOrigin = mid.x + '% ' + mid.y + '%';
list.style.overflow = 'hidden';
}
}, { passive: true });
list.addEventListener('pointermove', function (e) {
if (!pts[e.pointerId]) return; pts[e.pointerId] = { x: e.clientX, y: e.clientY };
if (img && Object.keys(pts).length === 2 && start) { var s = Math.min(3.5, Math.max(1, dist() / start)); img.style.transform = 'scale(' + s + ')'; }
}, { passive: true });
var end = function (e) {
delete pts[e.pointerId];
if (img && Object.keys(pts).length < 2) { img.classList.remove('is-pinching'); img.style.transform = ''; list.style.overflow = ''; img = null; start = 0; }
};
list.addEventListener('pointerup', end); list.addEventListener('pointercancel', end);
}
function homeCta() {
var bar = q('.tv-home-cta'), hero = q('.tv2-hero__actions'), end = q('.tv-cta');
if (!bar || !hero || !('IntersectionObserver' in w)) return;
var heroOut = false, endIn = false;
var set = function () { bar.classList.toggle('is-on', heroOut && !endIn && w.scrollY > 200); };
new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; set(); }).observe(hero);
if (end) new IntersectionObserver(function (es) { endIn = es[0].isIntersecting; set(); }, { threshold: 0.2 }).observe(end);
w.addEventListener('scroll', function () { var r = hero.getBoundingClientRect(); heroOut = r.bottom < 0; set(); }, { passive: true });
}
function bubble() {
/* Hide the Inbox bubble whenever, at rest, it would sit on top of a call to action (mobile only). */
if (!w.matchMedia || !w.matchMedia('(max-width: 749px)').matches) return;
var sel = '.tv-btn, .tv2-btn, .button, .product-form__submit, .quick-add__submit, .tv-set__cta, .tv-continue__link, .tv-tile, .tv-chip, .tv-quiz__opt, .tv-quiz button, .cart__checkout-button, .shopify-payment-button__button, button[name=add], .tv-switch__tab, .cart-remove-button .button, .newsletter-form__button, a.tv-link, .tv-tile__links a';
var timer = null, host = null;
var act = function () {
if (!host) host = q('shopify-chat'); if (!host || !host.shadowRoot) return null;
var find = function (r) { var b = r.querySelector('button.activator, .activator'); if (b) return b; var all = r.querySelectorAll('*'); for (var i = 0; i < all.length; i++) if (all[i].shadowRoot) { var x = find(all[i].shadowRoot); if (x) return x; } return null; };
return find(host.shadowRoot);
};
var check = function () {
var a = act(); if (!a) return;
var r = a.getBoundingClientRect(); if (!r.width) { d.documentElement.classList.remove('tv-bubble-hide'); return; }
var hit = false, els = d.querySelectorAll(sel);
for (var i = 0; i < els.length && !hit; i++) {
var el = els[i], b = el.getBoundingClientRect(); if (!b.width || b.bottom < 0 || b.top > w.innerHeight) continue;
var cs = getComputedStyle(el); if (cs.visibility === 'hidden' || cs.opacity === '0') continue;
if (el.closest('[hidden], .menu-drawer, cart-drawer:not(.active)')) continue;
hit = !(r.right <= b.left || r.left >= b.right || r.bottom <= b.top || r.top >= b.bottom);
}
d.documentElement.classList.toggle('tv-bubble-hide', hit);
};
var schedule = function () { d.documentElement.classList.remove('tv-bubble-hide'); clearTimeout(timer); timer = setTimeout(check, 160); };
w.addEventListener('scroll', schedule, { passive: true });
w.addEventListener('resize', schedule, { passive: true });
d.addEventListener('tv:recheck', schedule);
var tries = 0, poll = setInterval(function () { if (act() || ++tries > 40) { clearInterval(poll); check(); } }, 250);
}
function clampDesc() {
var el = q('.collection-hero__description'); if (!el || el.dataset.tvClamp) return; el.dataset.tvClamp = '1';
if (!w.matchMedia('(max-width: 749px)').matches) return;
if (el.getBoundingClientRect().height < 150) return;
el.classList.add('is-clamped');
var btn = d.createElement('button'); btn.type = 'button'; btn.className = 'tv-more'; btn.textContent = 'Read more'; btn.setAttribute('aria-expanded', 'false');
el.insertAdjacentElement('afterend', btn);
btn.addEventListener('click', function () { var open = el.classList.toggle('is-clamped'); btn.textContent = open ? 'Read more' : 'Show less'; btn.setAttribute('aria-expanded', open ? 'false' : 'true'); d.dispatchEvent(new Event('tv:recheck')); });
}
function init() { reveal(); dots(); switchers(); gallery(); homeCta(); clampDesc(); }
function boot() { press(); header(); tiles(); init(); bubble(); d.addEventListener('shopify:section:load', init); }
if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
